<template>
  <div id="BrandSwitching">
      <keep-alive include="centre">
            <company-switch :dataList="dataList"  @companySwitching="switchingChange"></company-switch>
      </keep-alive>
  </div>
</template>

<script>
// import { mapMutations } from "vuex";
import companySwitch from "@/components/companySwitch";
import { companyListApi } from "../../api/login";
export default {
  components: {
    companySwitch,
  },
  name: "centre",
  data() {
    return {
      dataList:[]
    };
  },
  created() {
    this.companySwitching();
  },
  methods: {
    // ...mapMutations(['setstoragecpyID']),
   async companySwitching() {
     await companyListApi().then((res) => { 
        this.dataList = res.data;
      });
    },
    switchingChange(val){
      // console.log(val)
      let cpyID = val;
      localStorage.setItem("cpyNo", cpyID);
    }
  },
};
</script>
<style lang="scss" scoped>
.span11 {
  margin-right: 10px;
}
</style>